module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8023.7a5ee755.png";